import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-942390b2")

_pushScopeId("data-v-942390b2")
const _hoisted_1 = { class: "select-sampledata" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "middle-header-text" }, " よく使われる、目的別のサンプル(セリフ付き)です。使用したいマンガをクリックして選択してください。 ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "header-dummy" }, null, -1)
const _hoisted_4 = { class: "button-list" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", { width: "95%" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "annotation" }, " ※サンプルはこのままお使いになることも、セリフやコマの順をアレンジして使う事も可能です。 ", -1)
const _hoisted_8 = { class: "template-list" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MiddleHeader = _resolveComponent("MiddleHeader")
  const _component_TemplateThumbnailSelectSample = _resolveComponent("TemplateThumbnailSelectSample")
  const _component_HorizontalListSelectSample = _resolveComponent("HorizontalListSelectSample")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MiddleHeader, null, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sampleAttribute, (item, i) => {
        return (_openBlock(), _createBlock("button", {
          class: "unselected-button",
          key: i,
          id: item.id.toString(),
          onClick: ($event: any) => (_ctx.selectAttribute(item.id))
        }, [
          _createVNode("span", null, _toDisplayString(item.name), 1)
        ], 8, ["id", "onClick"]))
      }), 128))
    ]),
    _hoisted_6,
    _hoisted_7,
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_HorizontalListSelectSample, {
        items: _ctx.sampleDatas,
        inPageCount: 5,
        emptyItem: _ctx.emptyTemplate,
        ref: "horizontalList"
      }, {
        default: _withId((slotProps) => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.inPageItems, (item) => {
            return (_openBlock(), _createBlock(_component_TemplateThumbnailSelectSample, {
              class: "thumbnail",
              key: item.id,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["items", "emptyItem"]),
      _hoisted_10
    ])
  ]))
})